import type { CheckoutItem, Currency } from "./index";

export function toMinorUnits(value: string | number): number {
  const normalized = String(value).replace(",", ".").trim();
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) throw new Error("Invalid money value");
  const [whole, cents = ""] = normalized.split(".");
  return Number(whole) * 100 + Number(cents.padEnd(2, "0"));
}

export function formatMoney(amount: number, currency: Currency = "BRL", locale = "pt-BR") {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount / 100);
}

export function addMoney(...amounts: number[]) {
  return amounts.reduce((total, amount) => total + amount, 0);
}

export function calculateSubtotal(items: Pick<CheckoutItem, "quantity" | "finalUnitPrice">[]) {
  return items.reduce((total, item) => total + item.quantity * item.finalUnitPrice, 0);
}

export function calculateTotal(input: {
  subtotal: number;
  discountAmount?: number;
  shippingAmount?: number;
}) {
  return Math.max(0, input.subtotal - (input.discountAmount ?? 0) + (input.shippingAmount ?? 0));
}
